import React from "react"
import { Link } from "gatsby"
import { ThemeProvider } from "styled-components"
import PostPreviewTags from "../post-preview-tags/post-preview-tags.component"
import dataLayerHelper from "../../helpers/datalayer.helper"
import { TimeIconContainer } from "./post-preview-card.styles"
import TimeIcon from "../../svg/Time.svg"
import {
  PostPreviewContainer,
  PostPreviewImg,
  PostPreviewImgContainer,
  PostPreviewContentContainer,
  ArticleTitle,
  ArticleDesc,
  ArticleAuthor,
  ArticleMetaData,
  ArticleAuthorCard,
  ArticleAuthorImg,
  PopularTextContainer,
  ArticleEdition,
} from "./post-preview-card.styles"

const PostPreviewCard = ({ blogPost, className, onTagChange, authorPage, nodatedisplay }) => {
  const theme = {
    desktop: "430px",
    ipad: "385px",
    mobile: "360px",
  }

  return (
    <PostPreviewContainer className={className} authorPage={authorPage}>
      <Link
        to={`/blog/${blogPost.slug}`}
        onClick={() =>
          dataLayerHelper({
            event: "blogPostCardClick",
            action: "Image Click",
            label: `Title: ${blogPost.blogTitle}`,
          })
        }
      >
        <PostPreviewImgContainer>
          <PostPreviewImg
            width="300"
            height="300"
            image={blogPost.heroImage.gatsbyImageData}
            alt={`${blogPost.blogTitle} preview`}
          />
          {blogPost.popular ? (
            <PopularTextContainer>
              <span>Popular</span>
            </PopularTextContainer>
          ) : null}
        </PostPreviewImgContainer>
      </Link>

      <ThemeProvider theme={theme}>
        <PostPreviewContentContainer authorPage={authorPage}>
          {!nodatedisplay ?
            (<ArticleMetaData>
              {blogPost.publishDate} <span> · </span>
              {
                blogPost.childContentfulBlogPostBodyTextNode.childMarkdownRemark
                  .fields.readingTime.text
              }
            </ArticleMetaData>) : (null)}
          <ArticleTitle
            to={`/blog/${blogPost.slug}`}
            onClick={() =>
              dataLayerHelper({
                event: "blogPostCardClick",
                action: "Title Click",
                label: `Title: ${blogPost.blogTitle}`,
              })
            }
          >
            {blogPost.blogTitle}
          </ArticleTitle>
          {nodatedisplay &&
            <TimeIconContainer>
              <TimeIcon />
              {
                blogPost.childContentfulBlogPostBodyTextNode.childMarkdownRemark
                  .fields.readingTime.text
              }
            </TimeIconContainer>
          }
          {blogPost.monthlyEdition ? (
            <ArticleEdition
              to={`/blog/${blogPost.slug}`}
              onClick={() =>
                dataLayerHelper({
                  event: "blogPostCardClick",
                  action: "Monthly Edition Click",
                  label: `Title: ${blogPost.blogTitle}`,
                })
              }
            >
              {blogPost.monthlyEdition}
            </ArticleEdition>
          ) : null}

          <ArticleDesc>{blogPost.excerpt}</ArticleDesc>
          {blogPost.author && (
            <>
              <ArticleAuthorCard>
                <ArticleAuthorImg
                  src={`${blogPost.author.profileImage.file.url}?w=35&fm=webp`}
                  alt={blogPost.author.authorName}
                  loading="lazy"
                />
                <ArticleAuthor>{blogPost.author.authorName}</ArticleAuthor>
              </ArticleAuthorCard>
              {!authorPage && (
                <>
                  <PostPreviewTags
                    onTagChange={onTagChange}
                    tags={blogPost.tags}
                    blogPost={blogPost}
                  />
                </>
              )}
            </>
          )}
        </PostPreviewContentContainer>
      </ThemeProvider>
    </PostPreviewContainer>
  )
}

export default PostPreviewCard
